<script>
  import NavLink from './NavLink.svelte';
  import NotificationItem from './Header/NotificationItem.svelte';
  import ProfileImg from './ProfileImage.svelte';
  import { client } from 'root/api/index.js';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { onMount, onDestroy, getContext } from 'svelte';
  import { Router, Link, navigate } from 'svelte-routing';
  import { authStore, getUserInfo } from '../stores/auth';
  import { unreadCount } from '../stores/unreadCount';
  import Loader from '../components/Loader.svelte';
  import { configItem } from 'components/Helper.js';
  const showDialog = getContext('showDialog');
  const confirmDraftStatus = getContext('confirmDraftStatus');
  let units = [];
  let isFormPending = false;

  let userRoleId = getUserInfo().roleId;
  //let userName=getUserInfo().firstName+" "+getUserInfo().lastName
  let userName = getUserInfo().firstName;
  let firstName = getUserInfo().firstName;
  let lastName = getUserInfo().lastName;

  let isUserNot = false;
  let showSettings = false;
  let notificationData = [];

  let photoUrl = getUserInfo().photoUrl;

  //var exampleEl = document.getElementById('anis')
  //var popover = new bootstrap.Popover(exampleEl, options)

  const getNotificationSummary = () => {
    isFormPending = true;
    notificationData = [];
    client
      .notificationSummary()
      .then((response) => {
        isFormPending = false;
        notificationData = response.data;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = getMasterData().units;
        let userRoles = getMasterData().userRoleId;
        isUserNot = ![userRoles?.manager, userRoles?.user].includes(userRoleId);
        showSettings = userRoles.admin == userRoleId || userRoles.unit_admin == userRoleId;
      }
    });
  });

  const unsubscribes = authStore.subscribe((state) => {
    if (state != undefined) {
      userRoleId = getUserInfo().roleId;
      //userName= getUserInfo().firstName+" "+getUserInfo().lastName;
      userName = getUserInfo().firstName;
      photoUrl = getUserInfo().photoUrl;
      firstName = getUserInfo().firstName;
      lastName = getUserInfo().lastName;
    }
  });
  onDestroy(() => {
    unsubscribe();
    unsubscribes();
  });

  let currentLink = window.location.pathname.substr(1);
  onMount(() => {
    var myDropdown = document.getElementById('notificationIcon');
    myDropdown.addEventListener('show.bs.dropdown', function () {
      getNotificationSummary();
    });
  });

  import { ROUTER } from 'svelte-routing/src/contexts';
  var { activeRoute } = getContext(ROUTER);
  $: {
    currentLink = $activeRoute?.uri?.substr(1);
  }
</script>

<nav class="navbar navbar-expand-lg navbar-dark bg-blue web-header">
  <div class="container-fluid gx-0">
    <div class="brand-logo">
      <NavLink
        to="/home"
        Style=" px-3 nav-items-link p-0"
      >
        <img
          alt=""
          src="/images/logo.png"
        />
      </NavLink>
    </div>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="collapse navbar-collapse mx-auto justify-content-end"
      id="navbarNavDropdown"
    >
      <ul class="navbar-nav d-flex align-items-center font-size-14">
        <li class="nav-item">
          <NavLink
            to="/home"
            onClick={() => {
              currentLink = 'home';
            }}
            Style="{currentLink == 'home' ? 'active' : ''} px-3 nav-items-link"
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 100 100"
                ><path
                  d="M46.875 0C51.1719 0 55.306 0.553385 59.2773 1.66016C63.2487 2.76693 66.9922 4.3457 70.5078 6.39648C74.0234 8.44727 77.181 10.8887 79.9805 13.7207C82.7799 16.5527 85.2214 19.7266 87.3047 23.2422C89.388 26.7578 90.9668 30.485 92.041 34.4238C93.1152 38.3626 93.6849 42.513 93.75 46.875C93.75 51.1719 93.1966 55.306 92.0898 59.2773C90.9831 63.2487 89.4043 66.9922 87.3535 70.5078C85.3027 74.0234 82.8613 77.181 80.0293 79.9805C77.1973 82.7799 74.0234 85.2214 70.5078 87.3047C66.9922 89.388 63.265 90.9668 59.3262 92.041C55.3874 93.1152 51.237 93.6849 46.875 93.75C42.5781 93.75 38.444 93.1966 34.4727 92.0898C30.5013 90.9831 26.7578 89.4043 23.2422 87.3535C19.7266 85.3027 16.569 82.8613 13.7695 80.0293C10.9701 77.1973 8.52865 74.0234 6.44531 70.5078C4.36198 66.9922 2.7832 63.265 1.70898 59.3262C0.634766 55.3874 0.0651042 51.237 0 46.875C0 42.5781 0.553385 38.444 1.66016 34.4727C2.76693 30.5013 4.3457 26.7578 6.39648 23.2422C8.44727 19.7266 10.8887 16.569 13.7207 13.7695C16.5527 10.9701 19.7266 8.52865 23.2422 6.44531C26.7578 4.36198 30.485 2.7832 34.4238 1.70898C38.3626 0.634766 42.513 0.0651042 46.875 0ZM46.875 87.5C50.6185 87.5 54.2155 87.0117 57.666 86.0352C61.1165 85.0586 64.3392 83.6914 67.334 81.9336C70.3288 80.1758 73.0794 78.0599 75.5859 75.5859C78.0924 73.112 80.2083 70.3776 81.9336 67.3828C83.6589 64.388 85.026 61.1491 86.0352 57.666C87.0443 54.1829 87.5326 50.5859 87.5 46.875C87.5 43.1315 87.0117 39.5345 86.0352 36.084C85.0586 32.6335 83.6914 29.4108 81.9336 26.416C80.1758 23.4212 78.0599 20.6706 75.5859 18.1641C73.112 15.6576 70.3776 13.5417 67.3828 11.8164C64.388 10.0911 61.1491 8.72396 57.666 7.71484C54.1829 6.70573 50.5859 6.21745 46.875 6.25C43.1315 6.25 39.5345 6.73828 36.084 7.71484C32.6335 8.69141 29.4108 10.0586 26.416 11.8164C23.4212 13.5742 20.6706 15.6901 18.1641 18.1641C15.6576 20.638 13.5417 23.3724 11.8164 26.3672C10.0911 29.362 8.72396 32.6009 7.71484 36.084C6.70573 39.5671 6.21745 43.1641 6.25 46.875C6.25 50.6185 6.73828 54.2155 7.71484 57.666C8.69141 61.1165 10.0586 64.3392 11.8164 67.334C13.5742 70.3288 15.6901 73.0794 18.1641 75.5859C20.638 78.0924 23.3724 80.2083 26.3672 81.9336C29.362 83.6589 32.6009 85.026 36.084 86.0352C39.5671 87.0443 43.1641 87.5326 46.875 87.5ZM55.2734 42.7734C55.9245 44.0755 56.25 45.4427 56.25 46.875C56.25 48.1771 56.0059 49.3978 55.5176 50.5371C55.0293 51.6764 54.362 52.6693 53.5156 53.5156C52.6693 54.362 51.6764 55.0293 50.5371 55.5176C49.3978 56.0059 48.1771 56.25 46.875 56.25C45.5729 56.25 44.3522 56.0059 43.2129 55.5176C42.0736 55.0293 41.0807 54.362 40.2344 53.5156C39.388 52.6693 38.7207 51.6764 38.2324 50.5371C37.7441 49.3978 37.5 48.1771 37.5 46.875C37.5 45.5729 37.7441 44.3522 38.2324 43.2129C38.7207 42.0736 39.388 41.0807 40.2344 40.2344C41.0807 39.388 42.0736 38.7207 43.2129 38.2324C44.3522 37.7441 45.5729 37.5 46.875 37.5C48.3073 37.5 49.6745 37.8255 50.9766 38.4766L50.9277 38.4277L68.8965 20.459L73.291 24.8535L55.3223 42.8223L55.2734 42.7734ZM46.875 50C47.7214 50 48.4538 49.6908 49.0723 49.0723C49.6908 48.4538 50 47.7214 50 46.875C50 46.0286 49.6908 45.2962 49.0723 44.6777C48.4538 44.0592 47.7214 43.75 46.875 43.75C46.0286 43.75 45.2962 44.0592 44.6777 44.6777C44.0592 45.2962 43.75 46.0286 43.75 46.875C43.75 47.7214 44.0592 48.4538 44.6777 49.0723C45.2962 49.6908 46.0286 50 46.875 50ZM78.125 32.8125C79.1341 35.026 79.8828 37.3047 80.3711 39.6484C80.8594 41.9922 81.1198 44.401 81.1523 46.875C81.1523 51.4323 80.306 55.8105 78.6133 60.0098C76.9206 64.209 74.4466 67.9362 71.1914 71.1914L66.748 66.748C69.3848 64.1113 71.4193 61.1003 72.8516 57.7148C74.2839 54.3294 75 50.765 75 47.0215C75 42.985 74.1536 39.0951 72.4609 35.3516L78.125 32.8125ZM58.3984 21.2891C54.6549 19.5964 50.765 18.75 46.7285 18.75C44.1569 18.75 41.6829 19.0755 39.3066 19.7266C36.9303 20.3776 34.7005 21.3379 32.6172 22.6074C30.5339 23.877 28.6458 25.3418 26.9531 27.002C25.2604 28.6621 23.8118 30.5664 22.6074 32.7148C21.403 34.8633 20.459 37.0931 19.7754 39.4043C19.0918 41.7155 18.75 44.2057 18.75 46.875C18.75 50.6185 19.4661 54.1992 20.8984 57.6172C22.3307 61.0352 24.3652 64.0788 27.002 66.748L22.5586 71.1914C19.3034 67.9362 16.8132 64.2253 15.0879 60.0586C13.3626 55.8919 12.5 51.4974 12.5 46.875C12.5 43.7174 12.9069 40.6738 13.7207 37.7441C14.5345 34.8145 15.6901 32.0801 17.1875 29.541C18.6849 27.002 20.4753 24.6908 22.5586 22.6074C24.6419 20.5241 26.9531 18.75 29.4922 17.2852C32.0312 15.8203 34.7656 14.6647 37.6953 13.8184C40.625 12.972 43.6849 12.5651 46.875 12.5977C49.3164 12.5977 51.709 12.8418 54.0527 13.3301C56.3965 13.8184 58.6914 14.5833 60.9375 15.625L58.3984 21.2891Z"
                  fill=""
                /></svg
              >
              Home</span
            >
          </NavLink>
        </li>
        <!-- Dashboard link to new gvine dashboard - Used button tag, as NavLink is not supporting opening new tab -->
        <li class="nav-item">
          <button
            class="nav-items-link bg-transparent px-3"
            on:click={() => (window.location.href = '/ui')}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="fill: transparent;"
                class="icon icon-tabler icons-tabler-outline icon-tabler-layout-dashboard"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                />
                <path
                  d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1"
                />
                <path
                  d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1"
                />
                <path
                  d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1"
                />
                <path
                  d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1"
                />
              </svg>
              Reports
            </span>
          </button>
        </li>
        {#if isUserNot}
          <li class="nav-item">
            <NavLink
              to="/user"
              onClick={() => {
                currentLink = 'user';
              }}
              Style="{currentLink == 'user' ? 'active' : ''} nav-items-link px-3"
            >
              <span>
                <svg
                  style="margin-top:-2px;"
                  width="16"
                  height="16"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M65.9062 59.4399C70.0977 60.9087 73.9115 63.0176 77.3477 65.7668C80.7839 68.516 83.748 71.6983 86.2402 75.3137C88.7324 78.9291 90.6393 82.8458 91.9609 87.0637C93.2825 91.2816 93.9622 95.5937 94 100H86.75C86.75 96.6859 86.3158 93.4848 85.4473 90.3966C84.5788 87.3085 83.3704 84.4275 81.8223 81.7536C80.2741 79.0797 78.3861 76.6506 76.1582 74.4663C73.9303 72.2821 71.4759 70.399 68.7949 68.8173C66.1139 67.2356 63.2253 66.0116 60.1289 65.1454C57.0326 64.2792 53.8229 63.8462 50.5 63.8462C47.1771 63.8462 43.9674 64.2792 40.8711 65.1454C37.7747 66.0116 34.8861 67.2167 32.2051 68.7608C29.5241 70.3049 27.0885 72.1879 24.8984 74.4099C22.7083 76.6318 20.8203 79.0797 19.2344 81.7536C17.6484 84.4275 16.4212 87.3085 15.5527 90.3966C14.6842 93.4848 14.25 96.6859 14.25 100H7C7 95.5937 7.66081 91.2816 8.98242 87.0637C10.304 82.8458 12.2109 78.9479 14.7031 75.3702C17.1953 71.7925 20.1595 68.6102 23.5957 65.8233C27.0319 63.0365 30.8646 60.9087 35.0937 59.4399C32.9792 58.0841 31.0911 56.5212 29.4297 54.7512C27.7682 52.9812 26.3333 51.0417 25.125 48.9327C23.9167 46.8237 23.0293 44.6018 22.4629 42.2668C21.8965 39.9319 21.5755 37.484 21.5 34.9231C21.5 30.9311 22.2552 27.1839 23.7656 23.6815C25.276 20.1791 27.334 17.1098 29.9395 14.4736C32.5449 11.8373 35.6224 9.76603 39.1719 8.25962C42.7214 6.75321 46.4974 6 50.5 6C54.5026 6 58.2598 6.75321 61.7715 8.25962C65.2832 9.76603 68.3607 11.8185 71.0039 14.4171C73.6471 17.0156 75.724 20.0849 77.2344 23.625C78.7448 27.1651 79.5 30.9311 79.5 34.9231C79.5 37.4463 79.1979 39.8754 78.5937 42.2103C77.9896 44.5453 77.0833 46.7861 75.875 48.9327C74.6667 51.0793 73.2506 53.0188 71.627 54.7512C70.0033 56.4836 68.0964 58.0465 65.9062 59.4399ZM28.75 34.9231C28.75 37.9359 29.3164 40.7416 30.4492 43.3401C31.582 45.9387 33.1302 48.236 35.0937 50.232C37.0573 52.228 39.3607 53.7909 42.0039 54.9207C44.6471 56.0505 47.4792 56.6154 50.5 56.6154C53.4831 56.6154 56.2962 56.0505 58.9395 54.9207C61.5827 53.7909 63.8861 52.2468 65.8496 50.2885C67.8131 48.3301 69.3802 46.0329 70.5508 43.3966C71.7214 40.7604 72.2878 37.9359 72.25 34.9231C72.25 31.9479 71.6836 29.1422 70.5508 26.506C69.418 23.8698 67.8698 21.5725 65.9062 19.6142C63.9427 17.6558 61.6204 16.0929 58.9395 14.9255C56.2585 13.758 53.4453 13.1931 50.5 13.2308C47.4792 13.2308 44.666 13.7957 42.0605 14.9255C39.4551 16.0553 37.1517 17.5994 35.1504 19.5577C33.1491 21.516 31.582 23.8321 30.4492 26.506C29.3164 29.1799 28.75 31.9856 28.75 34.9231Z"
                  /></svg
                >
                Users</span
              >
            </NavLink>
          </li>
        {/if}
        <li class="nav-item">
          <NavLink
            to="/client"
            onClick={() => {
              currentLink = 'client';
            }}
            Style="{currentLink == 'client' ? 'active' : ''} nav-items-link px-3"
            ><span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M79.8828 33.8379C81.9987 34.9121 83.903 36.2305 85.5957 37.793C87.2884 39.3555 88.7533 41.1133 89.9902 43.0664C91.2272 45.0195 92.1549 47.1029 92.7734 49.3164C93.3919 51.5299 93.7174 53.8411 93.75 56.25H87.5C87.5 53.6784 87.0117 51.2533 86.0352 48.9746C85.0586 46.696 83.7077 44.7103 81.9824 43.0176C80.2572 41.3249 78.2715 39.9902 76.0254 39.0137C73.7793 38.0371 71.3542 37.5326 68.75 37.5C66.1784 37.5 63.7533 37.9883 61.4746 38.9648C59.196 39.9414 57.2103 41.2923 55.5176 43.0176C53.8249 44.7428 52.4902 46.7285 51.5137 48.9746C50.5371 51.2207 50.0326 53.6458 50 56.25C50 59.2122 49.3327 62.028 47.998 64.6973C46.6634 67.3665 44.7917 69.5801 42.3828 71.3379C44.4987 72.4121 46.403 73.7305 48.0957 75.293C49.7884 76.8555 51.2533 78.6133 52.4902 80.5664C53.7272 82.5195 54.6549 84.6029 55.2734 86.8164C55.8919 89.0299 56.2174 91.3411 56.25 93.75H50C50 91.1784 49.5117 88.7533 48.5352 86.4746C47.5586 84.196 46.2077 82.2103 44.4824 80.5176C42.7572 78.8249 40.7715 77.4902 38.5254 76.5137C36.2793 75.5371 33.8542 75.0326 31.25 75C28.6784 75 26.2533 75.4883 23.9746 76.4648C21.696 77.4414 19.7103 78.7923 18.0176 80.5176C16.3249 82.2428 14.9902 84.2285 14.0137 86.4746C13.0371 88.7207 12.5326 91.1458 12.5 93.75H6.25C6.25 91.3737 6.57552 89.0788 7.22656 86.8652C7.8776 84.6517 8.80534 82.5684 10.0098 80.6152C11.2142 78.6621 12.6628 76.9043 14.3555 75.3418C16.0482 73.7793 17.9688 72.4447 20.1172 71.3379C17.7409 69.5801 15.8854 67.3665 14.5508 64.6973C13.2161 62.028 12.5326 59.2122 12.5 56.25C12.5 53.6784 12.9883 51.2533 13.9648 48.9746C14.9414 46.696 16.2923 44.7103 18.0176 43.0176C19.7428 41.3249 21.7285 39.9902 23.9746 39.0137C26.2207 38.0371 28.6458 37.5326 31.25 37.5C34.2122 37.5 37.028 38.1673 39.6973 39.502C42.3665 40.8366 44.5801 42.7083 46.3379 45.1172C47.5749 42.6758 49.1536 40.4948 51.0742 38.5742C52.9948 36.6536 55.1758 35.0749 57.6172 33.8379C55.2409 32.0801 53.3854 29.8665 52.0508 27.1973C50.7161 24.528 50.0326 21.7122 50 18.75C50 16.1784 50.4883 13.7533 51.4648 11.4746C52.4414 9.19596 53.7923 7.21029 55.5176 5.51758C57.2428 3.82487 59.2285 2.49023 61.4746 1.51367C63.7207 0.537109 66.1458 0.0325521 68.75 0C71.3216 0 73.7467 0.488281 76.0254 1.46484C78.304 2.44141 80.2897 3.79232 81.9824 5.51758C83.6751 7.24284 85.0098 9.22852 85.9863 11.4746C86.9629 13.7207 87.4674 16.1458 87.5 18.75C87.5 21.7122 86.8327 24.528 85.498 27.1973C84.1634 29.8665 82.2917 32.0801 79.8828 33.8379ZM31.25 68.75C32.9427 68.75 34.554 68.4245 36.084 67.7734C37.6139 67.1224 38.9323 66.2272 40.0391 65.0879C41.1458 63.9486 42.041 62.6302 42.7246 61.1328C43.4082 59.6354 43.75 58.0078 43.75 56.25C43.75 54.5573 43.4245 52.946 42.7734 51.416C42.1224 49.8861 41.2272 48.5677 40.0879 47.4609C38.9486 46.3542 37.6139 45.459 36.084 44.7754C34.554 44.0918 32.9427 43.75 31.25 43.75C29.5247 43.75 27.9134 44.0755 26.416 44.7266C24.9186 45.3776 23.6003 46.2728 22.4609 47.4121C21.3216 48.5514 20.4264 49.8861 19.7754 51.416C19.1243 52.946 18.7826 54.5573 18.75 56.25C18.75 57.9753 19.0755 59.5866 19.7266 61.084C20.3776 62.5814 21.2728 63.8997 22.4121 65.0391C23.5514 66.1784 24.8698 67.0736 26.3672 67.7246C27.8646 68.3757 29.4922 68.7174 31.25 68.75ZM56.25 18.75C56.25 20.4753 56.5755 22.0866 57.2266 23.584C57.8776 25.0814 58.7728 26.3997 59.9121 27.5391C61.0514 28.6784 62.3698 29.5736 63.8672 30.2246C65.3646 30.8757 66.9922 31.2174 68.75 31.25C70.4427 31.25 72.054 30.9245 73.584 30.2734C75.1139 29.6224 76.4323 28.7272 77.5391 27.5879C78.6458 26.4486 79.541 25.1302 80.2246 23.6328C80.9082 22.1354 81.25 20.5078 81.25 18.75C81.25 17.0573 80.9245 15.446 80.2734 13.916C79.6224 12.3861 78.7272 11.0677 77.5879 9.96094C76.4486 8.85417 75.1139 7.95898 73.584 7.27539C72.054 6.5918 70.4427 6.25 68.75 6.25C67.0247 6.25 65.4134 6.57552 63.916 7.22656C62.4186 7.8776 61.1003 8.77279 59.9609 9.91211C58.8216 11.0514 57.9264 12.3861 57.2754 13.916C56.6243 15.446 56.2826 17.0573 56.25 18.75Z"
                  fill=""
                /></svg
              >
              Clients</span
            ></NavLink
          >
        </li>
        <li class="nav-item">
          <NavLink
            to="/task"
            onClick={() => {
              currentLink = 'task';
            }}
            Style="{currentLink == 'task' ? 'active' : ''}  px-3 nav-items-link"
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M0 6.25H100V93.75H0V6.25ZM93.75 12.5H6.25V25H93.75V12.5ZM6.25 87.5H93.75V31.25H6.25V87.5ZM12.5 56.25V37.5H31.25V56.25H12.5ZM18.75 43.75V50H25V43.75H18.75ZM12.5 81.25V62.5H31.25V81.25H12.5ZM18.75 68.75V75H25V68.75H18.75ZM43.75 50V43.75H81.25V50H43.75ZM43.75 75V68.75H81.25V75H43.75Z"
                  fill=""
                /></svg
              >

              Task Dashboard</span
            >
          </NavLink>
        </li>
        {#if showSettings}
          <li class="nav-item">
            <NavLink
              to="/tasklibrary"
              onClick={() => {
                currentLink = 'tasklibrary';
              }}
              Style="{currentLink == 'tasklibrary' ? 'active' : ''} nav-items-link px-3"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 100 100"
                  ><path
                    d="M93 7V93H7V7H93ZM87.625 12.375H60.75V33.875H87.625V12.375ZM60.75 60.75H87.625V39.25H60.75V60.75ZM12.375 12.375V60.75H55.375V12.375H12.375ZM12.375 87.625H39.25V66.125H12.375V87.625ZM87.625 87.625V66.125H44.625V87.625H87.625Z"
                  /></svg
                >
                Task Library</span
              >
            </NavLink>
          </li>
        {/if}

        <li class="nav-item">
          <NavLink
            to="/assigntask"
            onClick={() => {
              currentLink = 'assigntask';
            }}
            Style="{currentLink == 'assigntask' ? 'active' : ''} nav-items-link px-3"
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M95 81.625L80.6855 95.8652L76.6342 91.8223L83.9715 84.5H56.3328V78.75H83.9715L76.6342 71.4277L80.6855 67.3848L95 81.625ZM66.9111 90.25L72.6729 96H16V15.5H39.0473C39.0473 13.9128 39.3474 12.4303 39.9476 11.0527C40.5478 9.67513 41.373 8.44727 42.4234 7.36914C43.4737 6.29102 44.6891 5.46745 46.0695 4.89844C47.45 4.32943 48.9504 4.02995 50.5709 4C52.1614 4 53.6469 4.29948 55.0273 4.89844C56.4078 5.4974 57.6382 6.32096 58.7185 7.36914C59.7989 8.41732 60.6241 9.63021 61.1943 11.0078C61.7645 12.3854 62.0646 13.8828 62.0946 15.5H85.1419V63.7012L79.3801 57.9512V21.25H73.6182V32.75H27.5236V21.25H21.7618V90.25H66.9111ZM33.2855 21.25V27H67.8564V21.25H56.3328V15.5C56.3328 14.6914 56.1827 13.9427 55.8826 13.2539C55.5825 12.5651 55.1774 11.9661 54.6672 11.457C54.1571 10.9479 53.5419 10.5286 52.8217 10.1992C52.1014 9.86979 51.3512 9.72005 50.5709 9.75C49.7607 9.75 49.0104 9.89974 48.3202 10.1992C47.63 10.4987 47.0298 10.903 46.5197 11.4121C46.0095 11.9212 45.5894 12.5352 45.2593 13.2539C44.9292 13.9727 44.7791 14.7214 44.8091 15.5V21.25H33.2855Z"
                  fill=""
                  stroke=""
                  stroke-width="1.3"
                /></svg
              >
              Assign Tasks</span
            >
          </NavLink>
        </li>

        {#if showSettings}
          <li class="nav-item">
            <NavLink
              to="/activitylog"
              onClick={() => {
                currentLink = 'activitylog';
              }}
              Style="{currentLink == 'activitylog' ? 'active' : ''} nav-items-link px-3"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 100 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M6.25 53.125V37.5H0V6.25H81.25V37.5H21.875L6.25 53.125ZM6.25 31.25H12.5V38.0371L19.2871 31.25H75V12.5H6.25V31.25ZM100 50V81.25H93.75V96.875L78.125 81.25H18.75V50H100ZM93.75 56.25H25V75H80.7129L87.5 81.7871V75H93.75V56.25Z"
                    fill=""
                  /></svg
                >
                Activity Log</span
              >
            </NavLink>
          </li>
        {/if}

        <li class="nav-item position-relative dropdown-notifications">
          <button
            type="button"
            id="notificationIcon"
            class="bg-transparent nav-items-button border-0 dropdown-toggle position-relative notification-icon"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            aria-expanded="false"
          >
            {#if $unreadCount > 0}
              <div class="small-notification position-absolute">
                {$unreadCount}
              </div>
            {/if}
            <svg
              id="Capa_1"
              enable-background="new 0 0 512 512"
              height="16"
              viewBox="0 0 512 512"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="m450.201 407.453c-1.505-.977-12.832-8.912-24.174-32.917-20.829-44.082-25.201-106.18-25.201-150.511 0-.193-.004-.384-.011-.576-.227-58.589-35.31-109.095-85.514-131.756v-34.657c0-31.45-25.544-57.036-56.942-57.036h-4.719c-31.398 0-56.942 25.586-56.942 57.036v34.655c-50.372 22.734-85.525 73.498-85.525 132.334 0 44.331-4.372 106.428-25.201 150.511-11.341 24.004-22.668 31.939-24.174 32.917-6.342 2.935-9.469 9.715-8.01 16.586 1.473 6.939 7.959 11.723 15.042 11.723h109.947c.614 42.141 35.008 76.238 77.223 76.238s76.609-34.097 77.223-76.238h109.947c7.082 0 13.569-4.784 15.042-11.723 1.457-6.871-1.669-13.652-8.011-16.586zm-223.502-350.417c0-14.881 12.086-26.987 26.942-26.987h4.719c14.856 0 26.942 12.106 26.942 26.987v24.917c-9.468-1.957-19.269-2.987-29.306-2.987-10.034 0-19.832 1.029-29.296 2.984v-24.914zm29.301 424.915c-25.673 0-46.614-20.617-47.223-46.188h94.445c-.608 25.57-21.549 46.188-47.222 46.188zm60.4-76.239c-.003 0-213.385 0-213.385 0 2.595-4.044 5.236-8.623 7.861-13.798 20.104-39.643 30.298-96.129 30.298-167.889 0-63.417 51.509-115.01 114.821-115.01s114.821 51.593 114.821 115.06c0 .185.003.369.01.553.057 71.472 10.25 127.755 30.298 167.286 2.625 5.176 5.267 9.754 7.861 13.798z"
              /></svg
            >
          </button>
          <div class="dropdown-menu dropdown-menu-lg-end top-header-menu">
            {#if isFormPending}
              <div class="d-flex align-items-center justify-content-center h-100 w-100">
                <Loader Style="loader-block" />
              </div>
            {:else}
              {#if notificationData.length == 0}
                <div
                  class="d-flex flex-column text-center justify-content-center align-items-center no-notificatios"
                >
                  <svg
                    fill="#787e8d"
                    id="Capa_1"
                    enable-background="new 0 0 512 512"
                    height="40"
                    viewBox="0 0 512 512"
                    width="50"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="m450.201 407.453c-1.505-.977-12.832-8.912-24.174-32.917-20.829-44.082-25.201-106.18-25.201-150.511 0-.193-.004-.384-.011-.576-.227-58.589-35.31-109.095-85.514-131.756v-34.657c0-31.45-25.544-57.036-56.942-57.036h-4.719c-31.398 0-56.942 25.586-56.942 57.036v34.655c-50.372 22.734-85.525 73.498-85.525 132.334 0 44.331-4.372 106.428-25.201 150.511-11.341 24.004-22.668 31.939-24.174 32.917-6.342 2.935-9.469 9.715-8.01 16.586 1.473 6.939 7.959 11.723 15.042 11.723h109.947c.614 42.141 35.008 76.238 77.223 76.238s76.609-34.097 77.223-76.238h109.947c7.082 0 13.569-4.784 15.042-11.723 1.457-6.871-1.669-13.652-8.011-16.586zm-223.502-350.417c0-14.881 12.086-26.987 26.942-26.987h4.719c14.856 0 26.942 12.106 26.942 26.987v24.917c-9.468-1.957-19.269-2.987-29.306-2.987-10.034 0-19.832 1.029-29.296 2.984v-24.914zm29.301 424.915c-25.673 0-46.614-20.617-47.223-46.188h94.445c-.608 25.57-21.549 46.188-47.222 46.188zm60.4-76.239c-.003 0-213.385 0-213.385 0 2.595-4.044 5.236-8.623 7.861-13.798 20.104-39.643 30.298-96.129 30.298-167.889 0-63.417 51.509-115.01 114.821-115.01s114.821 51.593 114.821 115.06c0 .185.003.369.01.553.057 71.472 10.25 127.755 30.298 167.286 2.625 5.176 5.267 9.754 7.861 13.798z"
                    /></svg
                  >
                  <span class="d-block mt-2 font-size-12 color-lead"
                    >You don't have any notification yet</span
                  >
                </div>
              {/if}
              <ul class="p-0">
                {#each notificationData as item}
                  <NotificationItem
                    url={item.url}
                    item={item}
                    message={item.message}
                    timeAgoStr={item.timeAgoStr}
                    time={item.timeDisplayTZ}
                  />
                {/each}
              </ul>
              <NavLink
                Style="border-0  text-center w-100 d-block pt-2 font-size-12 color-blue font-weight-500"
                to="/notifications"
              >
                View All
              </NavLink>
            {/if}
          </div>
        </li>

        {#if showSettings}
          <li class="px-1">
            <div class="btn-group btn-submenu settings-btn">
              <button
                type="button"
                class="bg-transparent btn-setting-icon border-0 dropdown-toggle position-relative"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
              >
                <!-- <svg id="Layer_1" fill="#fff" enable-background="new 0 0 24 24" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><g><path d="m13.12 24h-2.24c-.757 0-1.396-.567-1.486-1.32l-.239-1.876c-.477-.155-.937-.346-1.374-.569l-1.494 1.161c-.606.469-1.459.415-1.985-.126l-1.575-1.575c-.537-.521-.591-1.374-.122-1.979l1.161-1.495c-.224-.437-.415-.897-.569-1.374l-1.88-.239c-.75-.092-1.317-.731-1.317-1.488v-2.24c0-.757.567-1.396 1.32-1.486l1.876-.239c.155-.477.346-.937.569-1.374l-1.16-1.494c-.47-.606-.415-1.46.127-1.986l1.575-1.575c.521-.537 1.375-.59 1.979-.122l1.494 1.162c.437-.223.897-.414 1.375-.569l.239-1.88c.09-.75.729-1.317 1.486-1.317h2.24c.757 0 1.396.567 1.486 1.32l.239 1.876c.478.155.938.346 1.375.569l1.494-1.161c.607-.469 1.459-.415 1.985.127l1.575 1.575c.537.521.591 1.374.122 1.979l-1.161 1.495c.224.437.415.897.569 1.374l1.88.239c.749.091 1.316.73 1.316 1.487v2.24c0 .757-.567 1.396-1.32 1.486l-1.876.239c-.155.477-.346.937-.569 1.374l1.161 1.494c.47.606.415 1.459-.127 1.985l-1.575 1.575c-.521.537-1.375.592-1.979.122l-1.495-1.161c-.437.224-.897.415-1.374.569l-.239 1.88c-.091.75-.73 1.317-1.487 1.317zm-5.39-4.86c.083 0 .168.021.244.063.551.308 1.148.556 1.774.736.192.055.333.219.358.417l.28 2.2c.03.251.247.444.494.444h2.24c.247 0 .464-.193.493-.439l.281-2.204c.025-.198.166-.362.358-.417.626-.18 1.223-.428 1.774-.736.175-.098.393-.081.55.042l1.75 1.36c.201.156.483.143.655-.034l1.585-1.585c.181-.176.195-.458.039-.66l-1.36-1.75c-.123-.158-.14-.375-.042-.55.308-.551.556-1.148.736-1.774.055-.192.219-.333.417-.358l2.2-.28c.251-.031.444-.248.444-.495v-2.24c0-.247-.193-.464-.439-.493l-2.204-.281c-.198-.025-.362-.166-.417-.358-.18-.626-.428-1.223-.736-1.774-.098-.175-.082-.392.042-.55l1.36-1.75c.157-.202.143-.484-.033-.654l-1.585-1.585c-.175-.182-.458-.196-.66-.039l-1.75 1.36c-.159.123-.376.14-.551.042-.549-.308-1.146-.555-1.774-.736-.192-.055-.333-.219-.358-.417l-.28-2.2c-.031-.252-.248-.445-.495-.445h-2.24c-.247 0-.464.193-.493.439l-.281 2.204c-.025.198-.166.362-.358.418-.628.18-1.225.428-1.774.735-.175.099-.392.081-.551-.041l-1.75-1.36c-.202-.157-.483-.143-.654.033l-1.585 1.586c-.181.176-.195.458-.039.66l1.36 1.75c.123.158.14.375.042.55-.309.551-.556 1.148-.736 1.774-.055.192-.219.333-.417.358l-2.2.28c-.251.03-.444.247-.444.494v2.24c0 .247.193.464.439.493l2.204.281c.198.025.362.166.417.358.18.626.428 1.223.736 1.774.098.175.082.392-.042.55l-1.36 1.75c-.157.202-.143.484.033.654l1.585 1.585c.175.181.456.195.66.039l1.75-1.36c.091-.068.199-.104.308-.104z"/></g><g><path d="m12 17c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"/></g></svg> -->
                <img
                  src="/images/manage-list.svg"
                  height="20"
                  width="20"
                  alt=""
                />
              </button>
              <ul class="dropdown-menu dropdown-menu-lg-end top-header-menu">
                {#each units as unit}
                  <li>
                    <button
                      on:click={() => {
                        confirmDraftStatus({
                          okFunc: () => {
                            navigate(`/settings/${unit.id}`);
                          },
                        });
                      }}
                      type="button"
                      class="dropdown-item py-2 font-size-12 text-muted"
                    >
                      {unit.name}
                    </button>
                  </li>
                {/each}
              </ul>
            </div>
          </li>
        {/if}

        <li class="px-3">
          <div class="btn-group btn-submenu">
            <span
              class="text-white font-size-14"
              style="padding-top: 21px;padding-right: 10px;">Hi {userName}</span
            >

            <button
              type="button"
              class="bg-transparent btn-profile-img border-0 dropdown-toggle position-relative"
              data-bs-toggle="dropdown"
              data-bs-display="static"
              aria-expanded="false"
            >
              <ProfileImg
                size={40}
                photoUrl={photoUrl}
                firstName={firstName}
                lastName={lastName}
                className="d-inline-block align-middle header-user-profile"
              />
            </button>

            <ul class="dropdown-menu dropdown-menu-lg-end top-header-menu">
              <li>
                <NavLink
                  Style="dropdown-item py-2 font-size-12 text-muted"
                  to="/profile"
                >
                  <svg
                    class="me-1"
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><path
                      d="M65.9062 59.4399C70.0977 60.9087 73.9115 63.0176 77.3477 65.7668C80.7839 68.516 83.748 71.6983 86.2402 75.3137C88.7324 78.9291 90.6393 82.8458 91.9609 87.0637C93.2825 91.2816 93.9622 95.5937 94 100H86.75C86.75 96.6859 86.3158 93.4848 85.4473 90.3966C84.5788 87.3085 83.3704 84.4275 81.8223 81.7536C80.2741 79.0797 78.3861 76.6506 76.1582 74.4663C73.9303 72.2821 71.4759 70.399 68.7949 68.8173C66.1139 67.2356 63.2253 66.0116 60.1289 65.1454C57.0326 64.2792 53.8229 63.8462 50.5 63.8462C47.1771 63.8462 43.9674 64.2792 40.8711 65.1454C37.7747 66.0116 34.8861 67.2167 32.2051 68.7608C29.5241 70.3049 27.0885 72.1879 24.8984 74.4099C22.7083 76.6318 20.8203 79.0797 19.2344 81.7536C17.6484 84.4275 16.4212 87.3085 15.5527 90.3966C14.6842 93.4848 14.25 96.6859 14.25 100H7C7 95.5937 7.66081 91.2816 8.98242 87.0637C10.304 82.8458 12.2109 78.9479 14.7031 75.3702C17.1953 71.7925 20.1595 68.6102 23.5957 65.8233C27.0319 63.0365 30.8646 60.9087 35.0937 59.4399C32.9792 58.0841 31.0911 56.5212 29.4297 54.7512C27.7682 52.9812 26.3333 51.0417 25.125 48.9327C23.9167 46.8237 23.0293 44.6018 22.4629 42.2668C21.8965 39.9319 21.5755 37.484 21.5 34.9231C21.5 30.9311 22.2552 27.1839 23.7656 23.6815C25.276 20.1791 27.334 17.1098 29.9395 14.4736C32.5449 11.8373 35.6224 9.76603 39.1719 8.25962C42.7214 6.75321 46.4974 6 50.5 6C54.5026 6 58.2598 6.75321 61.7715 8.25962C65.2832 9.76603 68.3607 11.8185 71.0039 14.4171C73.6471 17.0156 75.724 20.0849 77.2344 23.625C78.7448 27.1651 79.5 30.9311 79.5 34.9231C79.5 37.4463 79.1979 39.8754 78.5937 42.2103C77.9896 44.5453 77.0833 46.7861 75.875 48.9327C74.6667 51.0793 73.2506 53.0188 71.627 54.7512C70.0033 56.4836 68.0964 58.0465 65.9062 59.4399ZM28.75 34.9231C28.75 37.9359 29.3164 40.7416 30.4492 43.3401C31.582 45.9387 33.1302 48.236 35.0937 50.232C37.0573 52.228 39.3607 53.7909 42.0039 54.9207C44.6471 56.0505 47.4792 56.6154 50.5 56.6154C53.4831 56.6154 56.2962 56.0505 58.9395 54.9207C61.5827 53.7909 63.8861 52.2468 65.8496 50.2885C67.8131 48.3301 69.3802 46.0329 70.5508 43.3966C71.7214 40.7604 72.2878 37.9359 72.25 34.9231C72.25 31.9479 71.6836 29.1422 70.5508 26.506C69.418 23.8698 67.8698 21.5725 65.9062 19.6142C63.9427 17.6558 61.6204 16.0929 58.9395 14.9255C56.2585 13.758 53.4453 13.1931 50.5 13.2308C47.4792 13.2308 44.666 13.7957 42.0605 14.9255C39.4551 16.0553 37.1517 17.5994 35.1504 19.5577C33.1491 21.516 31.582 23.8321 30.4492 26.506C29.3164 29.1799 28.75 31.9856 28.75 34.9231Z"
                      fill="#787e8d"
                    /></svg
                  >
                  Profile
                </NavLink>
              </li>
              <li>
                <button
                  on:click={() => {
                    confirmDraftStatus({
                      okFunc: () => {
                        client.logout();
                      },
                    });
                  }}
                  class="dropdown-item py-2 font-size-12 text-muted"
                >
                  <svg
                    class="me-1"
                    width="16"
                    height="16"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    ><g clip-path="url(#clip0)"
                      ><path
                        d="M56.75 87.5V87H56.25H13V6.75H56.25H56.75V6.25V0V-0.5H56.25H6.25H5.75V0V93.75V94.25H6.25H56.25H56.75V93.75V87.5ZM94.8363 47.2282L95.1888 46.875L94.8363 46.5218L71.057 22.6937L70.7035 22.3394L70.3496 22.6933L66.4433 26.5996L66.0893 26.9536L66.4438 27.3072L82.433 43.25H31.25H30.75V43.75V50V50.5H31.25H82.433L66.4438 66.4428L66.0893 66.7964L66.4433 67.1504L70.3496 71.0567L70.7035 71.4106L71.057 71.0563L94.8363 47.2282Z"
                        fill="#787e8d"
                        stroke="#787e8d"
                      /></g
                    ><defs
                      ><clipPath id="clip0"
                        ><rect
                          width="100"
                          height="100"
                          fill="white"
                        /></clipPath
                      ></defs
                    ></svg
                  >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="web-header d-none">
  <div class="d-flex flex-row justify-content-between align-items-center h-100">
    <div class="d-flex flex-row align-items-center">
      <div class="brand-logo me-3">
        <img
          alt=""
          src="/images/logo.png"
        />
      </div>
    </div>
    <div class="d-flex flex-row align-items-center right-contents-aera">
      <nav class="new-header-links"></nav>
      <div class="top-icons-block d-flex flex-row"></div>

      <div>
        <div
          class="dropdown-menu"
          aria-labelledby="dropdownMenuLink"
        >
          <a
            class="dropdown-item"
            href="_">Action</a
          >
          <a
            class="dropdown-item"
            href="_">Another action</a
          >
          <a
            class="dropdown-item"
            href="_">Something else here</a
          >
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .web-header {
    flex: 0 0 65px;
    dispaly: flex;
    height: 65px;
    -webkit-transition: top 0.3s ease;
    transition: top 0.3s ease;
    z-index: 95;
    -webkit-box-shadow: 0 10px 30px 0 rgba(82, 63, 105, 0.08);
    box-shadow: 0 10px 30px 0 rgba(82, 63, 105, 0.08);
    background-color: $blue-color;
    // padding: 0 25px;
    margin: 0;

    .brand-logo {
      background-color: #fff;
      padding: 10px 13px;
      img {
        max-height: 45px;
      }
    }
    .top-icons-block {
      padding: 0px 10px;
      svg {
        fill: #fff;
        color: #fff;
        width: 15px;
        height: 15px;
      }
      a {
        transition: all 0.2s ease-in-out;
        padding: 13px;
        margin-right: 0.5rem;
        &:hover {
          background-color: rgba(255, 255, 255, 0.9);
          svg {
            fill: #377dff;
          }
        }
      }
    }

    .new-header-links {
      span {
        vertical-align: middle;
        color: white;
        padding: 26px 11px;
      }
    }
    .right-contents-aera {
      padding-right: 20px;
    }

    .dropdown-notifications {
      .dropdown-menu {
        font-size: 12px;
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.25);
        border: 0;
        min-width: 25rem;
        font-size: 14px;
        border-radius: 4px;
        margin-top: 15px;
        &:before {
          display: inline-block;
          content: '';
          position: absolute;
          top: -10px;
          right: 12px;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #fff;
          border-left: 10px solid transparent;
        }

        ul {
          list-style: none;
          max-height: 300px;
          overflow-y: auto;
        }
      }

      .notification-icon {
        &:after {
          display: none;
        }
        svg {
          width: 20px;
          height: 20px;
          fill: #fff;
        }
      }
    }

    .btn-submenu {
      button {
        &:after {
          background-image: url(/images/down-arrow-white.svg);
        }
      }
      .btn-profile-img {
        padding: 11px 0;
      }
      .dropdown-menu {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.25);
        border: 0;
        min-width: 10rem;
        font-size: 14px;
        border-radius: 4px;
        margin-top: 15px;
        &:before {
          display: inline-block;
          content: '';
          position: absolute;
          top: -8px;
          right: 12px;
          border-right: 10px solid transparent;
          border-bottom: 10px solid #fff;
          border-left: 10px solid transparent;
        }
      }
    }
    .btn-setting-icon {
      height: 60px;
    }
  }

  .small-notification {
    background-color: $red-color;
    top: 11px;
    right: 7px;
    min-width: 20px;
    height: 17px;
    color: white;
    border-radius: 5px;
  }
  .no-notificatios {
    border-bottom: 1px solid $input-border-color;
    padding: 20px;
  }
</style>
